import { Component } from 'react'
import { connect } from 'react-redux'
import Selectors from '../../selectors'
import _ from 'lodash'

import {
  ModalCategorySelector,
  ModalCategoryItemSelector,
  ModalTitleSelector,
  TodoAssigneeSelector,
  TodoTimeSelector,
} from './components'

import { LoadingScreen, StepList, Step } from '../generic'
import Operations from '../../operations'
import Modal from '.'
import { ScrollLock } from '../../LEGACY/elemental'

type TaskCreateModalProps = {
  createItem: (options: any) => void
  onComplete?: () => void
  fields: any
  close: () => void
  isOpen: boolean
  summary: any
  carers: any
  categories: any
  items: any
  residents: any
  fetchDailyTodos: () => void
  fetchRecurringTodos: () => void
  showToast: (options: { title: string }) => void
}

class TaskCreateModal extends Component<TaskCreateModalProps> {
  constructor(props: TaskCreateModalProps) {
    super(props)
    this.checkDescriptionValid = this.checkDescriptionValid.bind(this)
    this.checkSubmitValid = this.checkSubmitValid.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleComplete = this.handleComplete.bind(this)
  }

  checkDescriptionValid() {
    if (!this.props.fields.title || !this.props.fields.description) return false
    return true
  }

  checkSubmitValid() {
    const {
      fields: { assignee, resident },
    } = this.props
    if (
      (!assignee && !resident) ||
      (assignee && !assignee.length) ||
      (resident && !resident.length)
    )
      return false
    return true
  }

  handleSubmit() {
    const { createItem, onComplete } = this.props
    createItem({
      url: 'list/recurring-tasks',
      onComplete: () => {
        this.handleComplete()
        onComplete?.()
      },
    })
  }

  handleComplete = () => {
    const { showToast } = this.props
    showToast({ title: 'Added a To-Do' })
  }

  render() {
    const {
      close,
      isOpen,
      summary,
      carers,
      categories,
      items,
      residents,
      ...formProps
    } = this.props
    if (!isOpen) return null
    if ([carers, categories, items, residents, summary].some((item) => !item))
      return <LoadingScreen />
    const { category, title, description } = formProps.fields
    const chosenItems = category && _.filter(items, { category })
    const {
      text,
      icon: { url, color },
    } = summary
    const validationText =
      title && title.length && description && description.length
        ? 'You need to assign residents or carers'
        : 'Title and Description is required'

    return (
      <div>
        <StepList
          onClose={close}
          backIconColor={color}
          backIcon={url}
          backText={text}
          closeLabel="Cancel"
        >
          <Step
            component={ModalCategorySelector}
            data={{ categories }}
            {...formProps}
          />
          <Step
            component={ModalCategoryItemSelector}
            data={{ items: chosenItems, categories }}
            {...formProps}
          />
          <Step
            component={ModalTitleSelector}
            isValid={this.checkDescriptionValid}
            validationText={validationText}
            showNextButton
            formId={FORM_ID}
            {...formProps}
          />
          <Step component={TodoTimeSelector} showNextButton {...formProps} />
          <Step
            component={TodoAssigneeSelector}
            data={{ residents, carers }}
            isValid={this.checkSubmitValid}
            onSubmit={this.handleSubmit}
            validationText={validationText}
            buttonGlyph="plus"
            {...formProps}
          />
        </StepList>
        <ScrollLock />
      </div>
    )
  }
}

const mapStateToProps = (state: any, props: any) => ({
  carers: state.data.carers,
  categories: state.data['log-categories'],
  items: state.data['log-category-items'],
  residents: state.data.residents,
  // @ts-ignore
  summary: Selectors.getTodoSummary(state, props),
})

const mapDispatchToProps = (dispatch: any) => ({
  fetchDailyTodos: () => dispatch(Operations.fetchDailyTodos()),
  fetchRecurringTodos: () => dispatch(Operations.fetchRecurringTodos()),
})

const FORM_ID = 'createTask'

const wrappedModal = connect(
  mapStateToProps,
  mapDispatchToProps
)(TaskCreateModal)

export default Modal(wrappedModal, FORM_ID)
